import { IntegrationSettingsBanner } from 'components/shared/banners/IntegrationSettingsBanner';
import { ProviderLimitExceededBanner } from 'components/shared/banners/ProviderLimitExceededBanner';
import useWizard from 'features/wizard/hooks/useWizard';
import React from 'react';
import { DashboardWelcome } from './dashboard-welcome/DashboardWelcome';
import { EmbeddedStatus } from './embedded-status/EmbeddedStatus';
import { usePrimaryProvider } from './hooks/usePrimaryProvider';
import OtherInfoCard from './OtherInfoCard';
import ScriptTagsBanner from './ScriptTagsBanner';
import { ShopifyTiles } from './ShopifyTiles';
import { WizardDashboard } from './WizardDashboard';

const DashBoardComponents: React.FC = () => {
    // const { currentSubscription, isLoading, isLegacy } = useCurrentSubscriptionHelper();
    const wizardHook = useWizard({ autoOpenFirstUndoneStep: true });
    const { provider: primaryProvider, country: primaryProviderCountry } = usePrimaryProvider();
    const wizardDone = wizardHook.isAllDone();

    return (
        <div className="flex flex-col gap-5">
            {/* <IntercomErrorBanner /> */}
            <div className="flex flex-col gap-4">
                <ProviderLimitExceededBanner />
                <DashboardWelcome />
                {/* <MonthlyLabelSummary loading={isLoading} hasSubscription={isLoading ? true : !!currentSubscription} /> */}
                <WizardDashboard />
                <OtherInfoCard />
                {wizardDone && <ShopifyTiles provider={primaryProvider} providerCountry={primaryProviderCountry} />}
                <IntegrationSettingsBanner />
                <ScriptTagsBanner />
                {wizardDone && <EmbeddedStatus />}
                {/* <OrderOverview /> */}
            </div>
        </div>
    );
};

export default DashBoardComponents;
